import { render, staticRenderFns } from "./NewButtonSet.vue?vue&type=template&id=8185e9e2&"
import script from "./NewButtonSet.vue?vue&type=script&lang=js&"
export * from "./NewButtonSet.vue?vue&type=script&lang=js&"
import style0 from "./NewButtonSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports